import { Avatar, Box, Stack, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { useRecoilValue } from 'recoil';

import { CardPartTitle } from '@app/components/Product/CardPartTitle';
import { userAuthInfoSelector } from '@app/domain/app';
import { Product } from '@app/types/catalog';

interface DetailInfoCardProps {
  product: Product;
}

export function DetailInfoCard({ product }: DetailInfoCardProps): ReactElement {
  const authInfo = useRecoilValue(userAuthInfoSelector);
  const organizationInfo =
    typeof product.organization === 'object'
      ? { ...product.organization }
      : null;
  const orgInfoArray = authInfo
    ? [
        organizationInfo?.name || '',
        [
          organizationInfo?.customFields?.addressByCity || '',
          organizationInfo?.addressLine3 || '',
          organizationInfo?.customFields?.addressLine4 || '',
        ]
          .filter((i) => i)
          .join(''),
      ]
    : [
        organizationInfo?.customFields?.addressByCity || '',
        organizationInfo?.customFields?.access || '',
      ].filter((i) => i);

  return (
    <Box>
      {organizationInfo?.iconImageUri && (
        <img
          alt={organizationInfo.name}
          src={organizationInfo.iconImageUri}
          style={{ width: '100%' }}
        />
      )}
      <Stack spacing={3} sx={{ p: 2 }}>
        <CardPartTitle product={product} />
        {organizationInfo && (
          <Stack direction="row" spacing={1}>
            <Avatar
              variant="square"
              sx={{ borderRadius: '8px', height: 32, width: 32 }}
            >
              {organizationInfo?.name
                ? organizationInfo.name.substring(0, 1)
                : ''}
            </Avatar>
            <Typography variant="body3" component="div" color="textSecondary">
              {orgInfoArray.map((value, index) => (
                <Box key={index}>{value}</Box>
              ))}
            </Typography>
          </Stack>
        )}
      </Stack>
    </Box>
  );
}
